export const state = {
  regulationtype: null,
  regulationtypes: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/regulationtype/state.js